import BaseApi from './BaseApi';

export function getMe() {
  return BaseApi.get(
    '/users/me',
  );
}
